import { Colors } from '../consts/Colors';
import { Sizes } from '../consts/Sizes';

export default class SwapActivity extends Phaser.GameObjects.Container {
    constructor(scene, x, y, images = [], letters = [], response = []) {
        super(scene, x, y);
        this.scene = scene;
        this.images = images;
        this.letters = letters;
        this.selected = null;

        this.reponse = response;

        this.imageSize = 140;
        this.spacing = 80;
        this.letterYOffset = 180;

        this.imageObjects = [];
        this.letterObjects = [];

        this.renderImages();
        this.renderLetters();

        scene.add.existing(this);
    }

    renderImages() {
        this.images.forEach((key, i) => {
            const posX = i * (this.imageSize + this.spacing);

            const image = this.scene.add
                .image(posX, 0, key)
                .setOrigin(0.5)
                .setDisplaySize(this.imageSize - 10, this.imageSize - 10)
                .setInteractive({ useHandCursor: true })
                .setScale(1.0);

            // Cadre basé sur this.imageSize
            const frame = this.scene.add
                .rexRoundRectangle(
                    posX,
                    0,
                    this.imageSize * 1.35,
                    this.imageSize * 1.35,
                    16,
                    Colors.Elmt.White
                )
                .setOrigin(0.5);

            image.bgFrame = frame;

            image.on('pointerdown', () => {
                image.isImage = true;
                this.handleSelect(image, i, true);
            });

            this.imageObjects.push(image);
            this.add([frame, image]);
        });
    }
    renderLetters() {
        this.letters.forEach((letter, i) => {
            const posX = i * (this.imageSize + this.spacing);

            const circle = this.scene.add.image(posX, this.letterYOffset, 'circle-swipe');

            const label = this.scene.add
                .text(posX, this.letterYOffset, letter, {
                    fontSize: Sizes.Text.h3,
                    fontFamily: 'Binx',
                    color: Colors.Text.BleuNovotel,
                })
                .setOrigin(0.5)
                .setInteractive({ useHandCursor: true });

            label.bgCircle = circle;
            label.letter = letter;
            label.isImage = false; // 👈 ici !

            this.letterObjects.push(label);
            this.add([circle, label]);

            this.letterContainer = this.scene.add.container(posX, this.letterYOffset);

            this.letterContainer.setSize(this.imageSize, this.imageSize); // Pour clics
            this.letterContainer.isImage = false;
            this.letterContainer.bgCircle = circle;
            this.letterContainer.label = label;
        });
    }

    handleSelect(target, index, isImage) {
        if (!this.selected) {
            this.selectItem(target, isImage);
        } else {
            const from = this.selected;
            const to = target;

            // Same type or same object → reset
            if (from === to || from.isImage !== isImage) {
                this.deselectAll();
                return;
            }

            this.swapItems(from, to);
        }
    }

    selectItem(target, isImage) {
        this.selected = target;
        this.selected.isImage = isImage;

        const frame = target.bgFrame;
        frame.setFillStyle(Colors.Elmt.BleuNovotel);
    }

    deselectAll() {
        this.selected = null;
        this.imageObjects.forEach((img) => {
            img.bgFrame.setFillStyle(Colors.Elmt.White);
        });
    }

    swapItems(a, b) {
        const ai = this.imageObjects.indexOf(a);
        const bi = this.imageObjects.indexOf(b);

        // Vérifie que ce sont bien deux images sélectionnées
        if (ai === -1 || bi === -1) return;

        const aLetter = this.letterObjects[ai];
        const bLetter = this.letterObjects[bi];

        // Objets liés aux images
        const aFrame = a.bgFrame;
        const bFrame = b.bgFrame;

        // Objets liés aux lettres
        const aCircle = aLetter.bgCircle;
        const bCircle = bLetter.bgCircle;

        // Met tout au premier plan
        [a, b, aFrame, bFrame, aLetter, bLetter, aCircle, bCircle].forEach((el) => {
            el.setDepth(1);
        });

        a.setDepth(2);
        aFrame.setDepth(1);
        b.setDepth(2);
        bFrame.setDepth(1);

        // Anime images
        this.animateSwap(a, aFrame, b.x, b.y);
        this.animateSwap(b, bFrame, a.x, a.y);

        // Anime lettres
        this.animateSwap(aLetter, aCircle, bLetter.x, bLetter.y);
        this.animateSwap(bLetter, bCircle, aLetter.x, aLetter.y);

        // Swap dans tableaux
        [this.imageObjects[ai], this.imageObjects[bi]] = [b, a];
        [this.letterObjects[ai], this.letterObjects[bi]] = [bLetter, aLetter];

        this.deselectAll();
        this.checkAnswers();
    }

    animateSwap(item, frame, targetX, targetY) {
        const isLetter = !!item.letter;
        const offsetY = isLetter ? -5 : 0;

        // Tween sur l’élément principal (image ou label)
        this.scene.tweens.add({
            targets: item,
            x: targetX,
            y: targetY + offsetY,
            scaleX: 1.2,
            scaleY: 1.2,
            duration: 400,
            ease: 'Sine.easeInOut',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: item,
                    scaleX: 1,
                    scaleY: 1,
                    duration: 150,
                    ease: 'Sine.easeOut',
                });
            },
        });

        // Tween sur le fond (cadre ou cercle) — sans offset !
        this.scene.tweens.add({
            targets: frame,
            x: targetX,
            y: targetY,
            scaleX: 1.2,
            scaleY: 1.2,
            duration: 400,
            ease: 'Sine.easeInOut',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: frame,
                    scaleX: 1,
                    scaleY: 1,
                    duration: 150,
                    ease: 'Sine.easeOut',
                });
            },
        });
    }

    checkAnswers() {
        if (!this.reponse || this.reponse.length === 0) return;

        this.letterObjects.forEach((label, i) => {
            const expected = this.reponse[i];
            const actual = label.text;

            if (actual === expected) {
                // ✅ Bonne réponse → fond vert
                if (label.bgCircle) {
                    label.bgCircle.setTint(Colors.Elmt.Green);
                    label.setColor(Colors.Text.White);

                    // Vérifie si toutes les lettres sont correctes
                    // Si oui, on affiche l'écran de fin
                    if (this.letterObjects.every((l, idx) => l.text === this.reponse[idx])) {
                        this.scene.time.delayedCall(1500, () => {
                            this.scene.showEndScreen();
                        });
                    }
                }

                // Désactive l'interaction
                label.disableInteractive();

                // Désactive aussi l'image correspondante
                const image = this.imageObjects[i];
                if (image) {
                    image.disableInteractive();
                    image.bgFrame.setFillStyle(Colors.Elmt.Green);
                }
            } else {
                // ❌ Mauvaise réponse → reset style
                if (label.bgCircle) label.bgCircle.clearTint?.();
                const image = this.imageObjects[i];
                if (image) {
                    image.setInteractive();
                    image.bgFrame.setFillStyle(Colors.Elmt.White);
                }
            }
        });
    }
}
